export default __webpack_public_path__ + "static/media/favicon.f2980f77.ico";